import HomePage from "./general";

export { HomePage };
